<script setup lang="ts">
import ToggleSwitch from 'primevue/toggleswitch'
import { useId } from 'vue'

const props = withDefaults(defineProps<{ label?: string; disabled?: boolean; id?: string; name?: string }>(), {
  label: '',
  disabled: false,
  id: undefined,
  name: undefined,
})

const model = defineModel<boolean | null | undefined>({ default: false })
const inputId = props.id || `switch-${useId()}`
</script>

<template>
  <div class="app-switch inline-flex items-center gap-2" data-kit="switch">
    <ToggleSwitch
      :model-value="Boolean(model)"
      :input-id="inputId"
      :name="name"
      :disabled="disabled"
      @update:model-value="(value: boolean) => (model = value)"
    />
    <label v-if="label || $slots.default" :for="inputId" class="cursor-pointer select-none">
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>
